import { isDesktop } from "react-device-detect";
import { DesktopPage } from "./DesktopPage";
import { MobilePage } from "./MobilePage";
import { useEffect, useState } from "react";
import defaultFlowConfig from "../../config/flowConfig.json";
import { fetchJSON } from "../../services/utilitiesService";
import { GeoLocationUrl } from "../../constants";
import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";

export const WelcomePage = ({ onFinish, onGeoBlock }) => {
  const { t } = useTranslation("homeModule");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchGeoLocation = async () => {
      if (defaultFlowConfig.allowedRegions?.length > 0) {
        try {
          const geoResponse = await fetchJSON(GeoLocationUrl);
          if (
            Object.keys(geoResponse).length > 0 &&
            defaultFlowConfig.allowedRegions.includes(
              defaultFlowConfig?.country_name,
            )
          ) {
            return false;
          } else {
            onGeoBlock();
          }
        } catch (error) {
          console.error("Geolocation fetch failed", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
        return false;
      }
    };

    fetchGeoLocation();
  }, [onGeoBlock]);

  return (
    <>
      {isLoading ? (
        <div className="home-loading-page">
          <CircularProgress
            disableShrink
            color="inherit"
            size={40}
            thickness={4}
          />
          <p className="loading-text">{t("initializing")}...</p>
        </div>
      ) : isDesktop ? (
        <DesktopPage />
      ) : (
        <MobilePage onFinish={onFinish} />
      )}
    </>
  );
};
